import { action } from 'typesafe-actions';
import type { RouteComponentProps } from 'react-router';

import { IUserInfo } from 'APIPackage/AuthModule/interfaces/IUserInfo';
import { IResponseError } from 'APIPackage/MainModule/interfaces/IResponseError';

import { AuthActionsEnum } from '../enums/AuthActionsEnum';
import { IAuthState } from '../interfaces/IAuthState';

export const setUserAction = (user: IUserInfo) => action(AuthActionsEnum.SET_USER, { user });
export const clearUserAction = () => action(AuthActionsEnum.CLEAR_USER);
export const authLogin = (username: string, password: string, history: RouteComponentProps['history']) =>
  action(AuthActionsEnum.AUTH_LOGIN, { username, password, history });
export const authSetError = (error?: IResponseError) => action(AuthActionsEnum.AUTH_SET_ERROR, { error });
export const authInitEsiaAuthProcess = (history: RouteComponentProps['history']) =>
  action(AuthActionsEnum.AUTH_INIT_ESIA_AUTH_PROCESS, { history });
export const authSetStage = (stage: IAuthState['stage']) => action(AuthActionsEnum.AUTH_SET_STAGE, { stage });
export const authSetOrganizations = (organizations: IAuthState['organizations']) =>
  action(AuthActionsEnum.AUTH_SET_ORGANIZATIONS, { organizations });
export const authLogout = () => action(AuthActionsEnum.AUTH_LOGOUT);
export const authSetIsLoggedOut = (isLoggedOut: boolean) =>
  action(AuthActionsEnum.AUTH_SET_IS_LOGGED_OUT, { isLoggedOut });
